import { render, staticRenderFns } from "./DashboardWidgetContractTable.vue?vue&type=template&id=0ecb4fb0&scoped=true"
import script from "./DashboardWidgetContractTable.vue?vue&type=script&lang=js"
export * from "./DashboardWidgetContractTable.vue?vue&type=script&lang=js"
import style0 from "./DashboardWidgetContractTable.vue?vue&type=style&index=0&id=0ecb4fb0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ecb4fb0",
  null
  
)

export default component.exports